import { FC, ReactNode } from 'react';
import { useMountEffect } from 'obt-common';
import { FormProvider, useForm } from 'rhf-v7';
import { RetryPaymentCheckoutFormValues } from './types';
import { customResolver } from './validation';

interface FormProps {
  children?: ReactNode;
}

/**
 * Container for children within the retry payment form context
 */
const RetryPaymentFormProvider: FC<FormProps> = ({ children }) => {
  const methods = useForm<RetryPaymentCheckoutFormValues>({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: customResolver,
    defaultValues: {
      selectedPaymentSourceIds: [],
    },
  });

  useMountEffect(() => {
    // Trigger revalidation to immediately show error message at the bottom panel and disable submit button
    methods.trigger();
  });

  return <FormProvider<RetryPaymentCheckoutFormValues> {...methods}>{children}</FormProvider>;
};

export default RetryPaymentFormProvider;
